import { render, staticRenderFns } from "./Reinscripcion.vue?vue&type=template&id=1482efd2&"
import script from "./Reinscripcion.vue?vue&type=script&lang=js&"
export * from "./Reinscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports